import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DialogInputModel, FirmModel } from 'countable@model';
import { AvatarModule } from 'ngx-avatars';
import { PLANS_ADDONS_MESSAGES } from 'src/app/helpers/plan-addons.constant';
import { DIALOG_TYPES } from 'src/app/helpers/stored-procedures.constant';
import { AclModel } from 'src/app/model/acl.model';
import { AclService } from 'src/app/services/acl.service';
import { FirmService } from 'src/app/services/firm.service';

@Component({
  imports: [CommonModule, MatButtonModule, FormsModule, AvatarModule, MatDialogModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule],
  selector: 'app-remove-and-reassign-flex',
  templateUrl: './remove-and-reassign-flex.component.html',
  styleUrl: './remove-and-reassign-flex.component.scss'
})
export class RemoveAndReassignFlexComponent implements OnInit {
  dialogType: DIALOG_TYPES = null;
  dialogHeader: string;
  dialogData: any;
  aclModel: AclModel = new AclModel();
  selectedData: any = null;
  deleteCmsMember: FormControl;
  firm: FirmModel = null;
  public plan_addons_messages = PLANS_ADDONS_MESSAGES;
  private destroyRef = inject(DestroyRef);

  constructor(public dialogRef: MatDialogRef<RemoveAndReassignFlexComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogInputModel,
    private firmService: FirmService, public aclService: AclService) {
  }

  ngOnInit(): void {
    this.aclService.subject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
      if (res) {
        this.aclModel = res;
      }
    });
    this.firmService.subject.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(firm => {
      if (firm) {
        this.firm = firm;
      }
    });
    this.deleteCmsMember = new FormControl();
    this.dialogData = this.data.data;
    this.dialogHeader = this.data.dialogHeader;
    this.dialogType = this.data.dialogType;
  }

  deleteCmsReassigned(value: string) {
    this.dialogRef.close(value);
  }

}
